export default {
    sizes: {},
    baseStyle: {
        borderColor: 'darkGray'
    },
    variants: {
        basic: {
            fontSize: '2xl',
            borderWidth: '1px',
            borderColor: 'borderGray',
            height: '122px',
            borderRadius: '0',
            paddingLeft: '20px',
            paddingRight: '14px',
            paddingTop: '10px',
            colorScheme: 'light',
            _focus: {
                borderWidth: '1px',
                borderColor: 'fullBlack'
            },
            _disabled: {
                opacity: '1',
                borderColor: 'borderGray',
                backgroundColor: 'whiteSmoke'
            },
            _invalid: {
                color: 'red',
                borderColor: 'red',
                _focus: {
                    borderColor: 'red'
                }
            },
            _focusVisible: {
                boxShadow: 'outline'
            },
            _placeholder: {
                color: 'darkGray'
            }
        },
        outline: {
            fontSize: '2xl',
            padding: '16px 20px',
            backgroundColor: 'white',
            borderWidth: '1px',
            borderTopColor: 'borderGray',
            borderBottomColor: 'borderGray',
            borderLeftColor: 'borderGray',
            borderRightColor: 'borderGray',
            borderRadius: '0',
            colorScheme: 'light',
            _focus: {
                borderWidth: '1px',
                borderColor: 'fullBlack'
            },
            _disabled: {
                opacity: '1',
                borderColor: 'borderGray',
                backgroundColor: 'whiteSmoke'
            },
            _invalid: {
                color: 'red',
                borderColor: 'red',
                _focus: {
                    borderColor: 'red'
                }
            },
            _focusVisible: {
                boxShadow: 'outline'
            },
            _placeholder: {
                color: 'darkGray'
            }
        }
    },
    defaultProps: {}
}
